import { z } from "zod"
import { PaginationSchema } from "../../shared/pagination_dtos"
import { QuerySchema } from "../../shared/query_dtos"
import { createSortSchema } from "../../shared/sort_dtos"

export const BackofficeReferralsSortFields = ["createdAt", "companyName", "contactName"] as const
export type BackofficeReferralsSortFieldsEnum = (typeof BackofficeReferralsSortFields)[number]
export const BackofficeReferralsSortSchema = createSortSchema(
  BackofficeReferralsSortFields,
  "createdAt",
  "desc",
)

export const GetBackofficeReferralsSchema = z.object({
  ...PaginationSchema.extend(QuerySchema.shape).extend(BackofficeReferralsSortSchema.shape).shape,
})

export const GetBackofficeReferralParamsSchema = z.object({
  id: z.string().transform(BigInt),
})

export const AddCreditsToReferralBodySchema = z.object({
  credits: z.int().positive(),
})
